import { ScrollTypeEnum } from "@/components/CommonLayout/constants";
import { LOGING_CALLBACK_URL, appDomain, appId } from "@/app/config";
export const enableScroll = () => {
  document.body.style.overflow = "auto";
  document.documentElement.style.overflow = "auto";
};
export const backToTopScroll = () => {
  window.scrollTo({
    top: 0,
    behavior: "instant",
  });
};

export const handleScroll = (id: ScrollTypeEnum) => {
  const targetElement = document.getElementById(id);
  if (targetElement) {
    // window.__FirstScreenScrollStatus__ = true;

    setTimeout(() => {
      const { top } = targetElement.getBoundingClientRect();
      const offset = 100;

      const targetPosition = top + window.scrollY - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }, 10);
  } else {
    console.error(`Element with id ${id} not found.`);
  }
};

export const pxToRem = (px: number): string => {
  return `${px / 100}rem`;
};

export const onLogin = async (scene: string = "account", params?: Record<string, string>) => {
  // 如果没有提供 scene，则使用当前路由作为 scene
  const currentScene = scene || window.location.pathname.replace(/^\/|\/$/g, "");

  const nonce = Math.random().toString(36).substring(7);
  const state = Math.random().toString(36).substring(7);
  const scope = "openid profile email phone address";
  let redirectUri = `${new URL(window.location.href).origin}/${LOGING_CALLBACK_URL}${currentScene}`;
  if (params && Object.keys(params).length > 0) {
    const paramString = Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join("&");

    redirectUri += `&${paramString}`;
  }

  const url = `${appDomain}/oidc/auth?nonce=${nonce}&state=${state}&scope=${scope}&response_type=code&response_mode=query&redirect_uri=${encodeURIComponent(
    redirectUri!
  )}&client_id=${appId}`;
  window.location.href = url;
};

export async function logout() {
  localStorage.removeItem("fellou.access_token");
  localStorage.removeItem("fellou.id_token");
  localStorage.removeItem("fellou.userInfo");
  const currentUrl = new URL(window.location.href).origin;
  const logoutUrl = `${appDomain}/login/profile/logout?redirect_uri=${encodeURIComponent(currentUrl)}`;

  console.log(logoutUrl, "logoutUrllogoutUrl dft");

  window.location.href = logoutUrl;
}
